import { useState } from "react";
import { connect } from "react-redux";
import { bool, func, arrayOf, shape } from "prop-types";
import Checkbox from "@shared/v2/Checkbox";
import PurchaseAndSaleAgreement from "./PurchaseAndSaleAgreement";
import AdditionalDocument from "./AdditionalDocument";
import { getBlueprintTitledocument, setDocumentIndex } from "../../../Main/Docs/actions/creators";
import { formatFileSize } from "../../../../PersonDetail/actions/helper";

const getFileType = (fileName) => {
  const extension = fileName.split(".").pop().toUpperCase();
  const allowedTypes = ["PDF", "JPG", "JPEG", "GIF", "PNG", "DOC", "DOCX", "XLSX"];
  return allowedTypes.includes(extension) ? extension : "UNKNOWN";
};

const createDoc = (file, index) => ({
  fileExtension: `.${file?.name.split(".").pop()}`,
  url: null,
  uploadedById: null,
  uploadedByImageUrl: null,
  uploadedByImage: null,
  uploadedByName: null,
  uploadedByUrl: null,
  fileName: file?.name,
  fileType: getFileType(file?.name),
  humanReadableSize: formatFileSize(file?.size),
  id: file?.lastModified.toString() + index.toString() + file.size.toString(),
  nakedName: `${file?.name.split(".")[0]}`,
  imageIcon: null,
  size: file?.size,
  uploadedAt: Date.now(),
  addedAgo: null,
  dateAdded: null,
  expiringUrl: URL.createObjectURL(file),
  documentType: "blueprint_title",
  documentSubType: "",
  isCreated: true,
  fileObj: file,
  canRename: false,
});

const SubmitPurchaseAndSale = ({
  uploadedFile,
  setUploadedFile,
  uploadedAdditionalFile,
  setUploadedAdditionalFile,
  setIsChecked,
  isChecked,
  getBlueprintTitledocument,
  blueprintTitleDoc,
  onSetDocumentIndex,
}) => {
  const handleFileDrop = (event) => {
    event.preventDefault();
    if (event.dataTransfer.files[0]) {
      setUploadedFile(event.dataTransfer.files[0]);
    }
  };

  const documentUpload = (event) => {
    const newFile = event.target.files[0];
    if (newFile) {
      setUploadedFile(newFile);
      getBlueprintTitledocument({
        ...blueprintTitleDoc,
        PurchaseAndSaleAgreement: [createDoc(newFile, "PnS")],
      });
    }
  };
  const onFilePreview = () => {
    onSetDocumentIndex("blueprintTitle-PurchaseAndSale-document", 0); //as theres only one Purchase And Sale Agreement doc
  };

  const handleAdditionalFileDrop = (event) => {
    event.preventDefault();
    if (event.dataTransfer.files) {
      setUploadedAdditionalFile((prevFiles) => [...prevFiles, ...Array.from(event.dataTransfer.files)]);
    }
  };

  const additionalDocumentUpload = (event) => {
    if (!event.target.files) return; // Prevents reading properties of null
    const newFiles = Array.from(event.target.files);
    setUploadedAdditionalFile((prevFiles) => [...prevFiles, ...newFiles]);

    const newFilesupload = Array.from(event.target.files).map((file, index) => createDoc(file, index));
    getBlueprintTitledocument({
      ...blueprintTitleDoc,
      AdditionalDoc: [...blueprintTitleDoc.AdditionalDoc, ...newFilesupload],
    });
    // Reset file input field
    event.target.value = null;
  };

  const handleAdditionalFileReplace = (index, newFile) => {
    if (newFile) {
      setUploadedAdditionalFile((prevFiles) => {
        const updatedFiles = [...prevFiles];
        updatedFiles[index] = newFile;
        return updatedFiles;
      });

      getBlueprintTitledocument({
        ...blueprintTitleDoc,
        AdditionalDoc: blueprintTitleDoc.AdditionalDoc.map((fileObj) =>
          fileObj.id === fileObj.lastModified.toString() + index.toString() + fileObj.size.toString()
            ? createDoc(newFile, index)
            : fileObj,
        ),
      });
    }
  };

  const handleFileDelete = (index) => {
    setUploadedAdditionalFile((prevFiles) => prevFiles.filter((_, i) => i !== index));
    getBlueprintTitledocument({
      ...blueprintTitleDoc,
      AdditionalDoc: blueprintTitleDoc.AdditionalDoc.filter(
        (fileObj) =>
          fileObj.id !== fileObj.lastModified.toString() + index.toString() + fileObj.size.toString(),
      ),
    });
  };

  const onAdditinalFilePreview = (index) => {
    onSetDocumentIndex("blueprintTitle-Additional-document", index);
  };
  return (
    <div>
      <div className="tw-py-[32px]">
        <div className="tw-text-14px tw-leading-[20px] tw-font-semibold tw-text-gray-75">
          Submit a Purchase and Sale Agreement (PSA)
        </div>
        <div className="tw-pt-[5px] tw-text-14px tw-leading-[20px] tw-font-normal tw-text-gray-75">
          Please submit a completed and signed PSA contract to start the title process. Your PSA will be
          reviewed and approved within a few business hours.{" "}
          <span
            className="tw-cursor-pointer tw-text-semantic-blue-110"
            onClick={() =>
              window.open("https://www.brivityknowledge.com/docs/blueprint-title-integration", "_blank")
            }
          >
            Learn More
          </span>
          <div className="tw-pt-[20px]">
            Blueprint must be listed as the title company in the PSA or an addendum.
          </div>
        </div>
      </div>
      <PurchaseAndSaleAgreement
        handleFileDrop={handleFileDrop}
        handleDocumentUpload={documentUpload}
        uploadedFile={uploadedFile}
        onFilePreview={onFilePreview}
      />
      <div className="tw-pt-[8px]"></div>
      <AdditionalDocument
        handleFileDrop={handleAdditionalFileDrop}
        handleDocumentUpload={additionalDocumentUpload}
        uploadedFiles={uploadedAdditionalFile}
        handleFileReplace={handleAdditionalFileReplace}
        handleFileDelete={handleFileDelete}
        onAdditinalFilePreview={onAdditinalFilePreview}
      />
      <div className="tw-pt-[8px]"></div>
      <Checkbox
        label="Add all documents to this transaction in Brivity"
        onChange={() => setIsChecked(!isChecked)}
        checked={isChecked}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  blueprintTitleDoc: state.tdpDocumentsReducer.blueprintTitleDoc,
});

const mapDispatchToProps = (dispatch) => ({
  getBlueprintTitledocument: (blueprintTitleDoc) => dispatch(getBlueprintTitledocument(blueprintTitleDoc)),
  onSetDocumentIndex: (context, index) => dispatch(setDocumentIndex(context, index)),
});

SubmitPurchaseAndSale.propTypes = {
  uploadedFile: shape({}),
  setUploadedFile: func,
  uploadedAdditionalFile: arrayOf(shape({})),
  setUploadedAdditionalFile: func,
  setIsChecked: func,
  isChecked: bool,
  getBlueprintTitledocument: func,
  blueprintTitleDoc: shape({
    PurchaseAndSaleAgreement: arrayOf(shape({})),
    AdditionalDoc: arrayOf(shape({})),
  }),
  onSetDocumentIndex: func,
};

SubmitPurchaseAndSale.defaultProps = {
  uploadedFile: null,
  setUploadedFile: null,
  uploadedAdditionalFile: [],
  blueprintTitleDoc: { PurchaseAndSaleAgreement: [], AdditionalDoc: [] },
  setUploadedAdditionalFile: null,
  setIsChecked: null,
  isChecked: true,
  getBlueprintTitledocument: null,
  onSetDocumentIndex: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubmitPurchaseAndSale);
